import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { IReceiver } from "dto/IPackage";
import { useMemo, useRef } from "react";
import { useOnClickOutside } from "hooks/useClickOutside";
import statusService from "api/statusService";
import OutgoingParcelReceiverRow from "components/OutgoingParcelReceiverRow";
import casesService from "api/casesService";
import { ICaseParticipant } from "dto/Cases/ICaseParticipant";

const OutgoingParcelReceiversModal: FC<Props> = ({ pack, toggle }) => {
  const { data: caseData } = casesService.useGetCase(
    pack.Case?.Id,
    null,
    pack?.Case?.Id !== null
  );
  const { mutate: saveCase } =
    casesService.useCreateCase();

  const ref = useRef(null);
  const hasCc = pack.Receivers.find((r) => r.Cc || r.Bcc);

  const { data: statusesData } = statusService.useGetStatuses();

  const statusList = useMemo(() => statusesData?.data ?? [], [statusesData]);

  const handleAddReceiverToCase = (r: IReceiver) => {
    const newParticipant: ICaseParticipant = {
      Id: null,
      Label: r.Name,
      Email: r.Email,
      EDeliveryAddress: r.EDeliveryAddress,
      DefaultParcelType: r.ParcelType,
      RoleId: null,
      IsMain: false,
    };
    caseData.Participants = [newParticipant, ...(caseData.Participants ?? [])];

    saveCase(caseData, {
      onSuccess() {},
    });
  };

  useOnClickOutside(ref, () => {
    toggle();
  });

  return (
    <div ref={ref} className={styles.modal}>
      <div className={styles.body}>
        <div className={styles.label}>Do:</div>
        <div className={styles.list}>
          {pack.Receivers.filter((r) => !r.Cc && !r.Bcc).map((r, index) => (
            <>
              <OutgoingParcelReceiverRow
                pack={pack}
                key={"oprr_" + index}
                receiver={r}
                statuses={statusList}
                addReceiverToCase={
                  pack?.Case?.Id ? handleAddReceiverToCase : null
                }
              />
            </>
          ))}
        </div>
        {hasCc && <div className={styles.label}>Dw:</div>}
        {hasCc && (
          <div className={styles.list}>
            {pack.Receivers.filter((r) => r.Cc || r.Bcc).map((r, index) => (
              <>
                <OutgoingParcelReceiverRow
                  pack={pack}
                  key={"oprr_" + index}
                  receiver={r}
                  statuses={statusList}
                  addReceiverToCase={
                    pack?.Case?.Id ? handleAddReceiverToCase : null
                  }
                />
              </>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default OutgoingParcelReceiversModal;
